import { useEffect } from "react";
import { animate, stagger } from "animejs";
import useReducedMotion from "./useReducedMotion";

export default function usePageReveal(deps = []) {
	const reduced = useReducedMotion();
	useEffect(() => {
		const targets = document.querySelectorAll("[data-reveal]");
		if (targets.length === 0) return;

		if (reduced) {
			targets.forEach((el) => {
				el.style.opacity = "1";
				el.style.transform = "none";
			});
			return;
		}

		// Initialize hidden state
		targets.forEach((el) => {
			el.style.opacity = "0";
			el.style.transform = "translateY(16px)";
		});

		const a = animate(targets, {
			opacity: [0, 1],
			translateY: [16, 0],
			duration: 580,
			delay: stagger(70),
			ease: "outQuad",
		});

		return () => a.pause?.();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
}
